// extracted by mini-css-extract-plugin
export default {"NavbarMainContainer":"Navbar_NavbarMainContainer__VFLkh","NavbarRightDiv":"Navbar_NavbarRightDiv__zwcXu","sovrennLogo":"Navbar_sovrennLogo__02NTt"};